export default (url: URL, params: {[name: string]: string}): URL => {
    const newURL = new URL(url.toString());

    for (const key in params) {
        newURL.searchParams.append(key, params[key].toString());
    }

    return newURL;
};
